import { render, staticRenderFns } from "./BigPhoneBlock.vue?vue&type=template&id=eb0db772&scoped=true&"
import script from "./BigPhoneBlock.vue?vue&type=script&lang=js&"
export * from "./BigPhoneBlock.vue?vue&type=script&lang=js&"
import style0 from "./BigPhoneBlock.vue?vue&type=style&index=0&id=eb0db772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0db772",
  null
  
)

export default component.exports